var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_46382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9501 26.4057C20.9249 26.4057 26.579 20.7515 26.579 13.7768C26.579 6.80208 20.9249 1.14795 13.9501 1.14795C6.97542 1.14795 1.32129 6.80208 1.32129 13.7768C1.32129 20.7515 6.97542 26.4057 13.9501 26.4057Z",
    stroke: "#0C1C33",
    strokeWidth: 1.50361
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1258 11.1771V10.0804C15.1258 9.55433 15.4742 9.4284 15.7264 9.4284H17.2603V7.08643H15.1483C12.799 7.08643 12.2727 8.82057 12.2727 9.94707V11.1771H10.9092V12.8297V13.9119H12.2876V20.7446H15.0223V13.9119H17.0454L17.1343 12.8372L17.2973 11.1771H15.1258Z",
    fill: "#0C1C33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_46382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0651,
    height: 27.0651,
    fill: "white",
    transform: "translate(0.425781 0.396484)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFace);
export default __webpack_public_path__ + "static/media/ic-face.e6b7122489fac242e6833c2bbc1d7387.svg";
export { ForwardRef as ReactComponent };